import { useMemo } from 'react';
import { parseHtmlStringToDom } from '../components/shared/utils/domParser';
/**
 * Parses the the HTML string passed to it and extracts the text content from
 * it. ex: <div><p>hello world</p></div> => hello world
 */
export function useParsedHtmlTextContent(html) {
    const search = useMemo(() => (html ? parseHtmlStringToDom(html).body.textContent : ''), [html]);
    return search || '';
}
